// Equipment category options
export const equipmentCategories = [
    { value: 'helmet', label: 'Helmet' },
    { value: 'armor', label: 'Armor' },
    { value: 'cloak', label: 'Cloak' },
    { value: 'amulet', label: 'Amulet' },
    { value: 'belt', label: 'Belt' },
    { value: 'weapon', label: 'Weapon' },
    { value: 'two_handed_weapon', label: 'Two Handed Weapon' },
    { value: 'shield', label: 'Shield' },
    { value: 'boots', label: 'Boots' },
    { value: 'leggings', label: 'Leggings' },
    { value: 'ring', label: 'Ring' },
    { value: 'potion', label: 'Potion' },
    { value: 'scroll', label: 'Scroll' },
    { value: 'rations', label: 'Rations' },
    { value: 'tools', label: 'Tools' },
    { value: 'trinket', label: 'Trinket' },
    { value: 'gear', label: 'Gear' }
]

// Edition-specific property configurations with icons, icon sets, and colors
export const editionProperties = {
    'toa': {
        name: { label: 'Name', icon: 'tag', iconSet: 'fas', color: 'text-blue-400', type: 'text' },
        category: { label: 'Category', icon: 'folder', iconSet: 'fas', color: 'text-orange-400', type: 'select', options: equipmentCategories },
        description: { label: 'Description', icon: 'align-left', iconSet: 'fas', color: 'text-cyan-400', type: 'text' },
        cost: { label: 'Cost', icon: 'coins', iconSet: 'fas', color: 'text-yellow-400', type: 'number' },
        armor: { label: 'Armor', icon: 'shield', iconSet: 'fas', color: 'text-emerald-400', type: 'number' },
        armor_class: { label: 'Armor Class', icon: 'shield', iconSet: 'fas', color: 'text-emerald-400', type: 'number' },
        damage_dice: { label: 'Damage Dice', icon: 'dice', iconSet: 'fas', color: 'text-red-400', type: 'dice' },
        heal_dice: { label: 'Heal Dice', icon: 'heart', iconSet: 'fas', color: 'text-pink-400', type: 'dice' },
        effects: { label: 'Effects', icon: 'sparkles', iconSet: 'fas', color: 'text-purple-400', type: 'text' },
        duration: { label: 'Duration', icon: 'clock', iconSet: 'fas', color: 'text-indigo-400', type: 'number' },
        charges: { label: 'Charges', icon: 'battery-full', iconSet: 'fas', color: 'text-blue-400', type: 'number' },
        properties: { label: 'Properties', icon: 'list', iconSet: 'fas', color: 'text-gray-400', type: 'text' },
        weight: { label: 'Weight', icon: 'weight', iconSet: 'fas', color: 'text-green-400', type: 'text' },
        ai_instructions: { label: 'AI Instructions', icon: 'robot', iconSet: 'fas', color: 'text-violet-400', type: 'text' }
    },
    '5e': {
        name: { label: 'Name', icon: 'tag', iconSet: 'fas', color: 'text-blue-400', type: 'text' },
        category: { label: 'Category', icon: 'folder', iconSet: 'fas', color: 'text-orange-400', type: 'select', options: equipmentCategories },
        description: { label: 'Description', icon: 'align-left', iconSet: 'fas', color: 'text-cyan-400', type: 'text' },
        cost: { label: 'Cost', icon: 'coins', iconSet: 'fas', color: 'text-yellow-400', type: 'text' },
        weight: { label: 'Weight', icon: 'weight', iconSet: 'fas', color: 'text-green-400', type: 'text' },
        magic_effects: { label: 'Magic Effects', icon: 'magic', iconSet: 'fas', color: 'text-purple-400', type: 'text' },
        damage: { label: 'Damage', icon: 'sword', iconSet: 'far', color: 'text-red-400', type: 'dice' },
        range: { label: 'Range', icon: 'bullseye', iconSet: 'fas', color: 'text-amber-400', type: 'text' },
        armor: { label: 'Armor', icon: 'shield', iconSet: 'fas', color: 'text-emerald-400', type: 'number' },
        properties: { label: 'Properties', icon: 'list', iconSet: 'fas', color: 'text-gray-400', type: 'text' },
        ai_instructions: { label: 'AI Instructions', icon: 'robot', iconSet: 'fas', color: 'text-violet-400', type: 'text', adminOnly: true }
    },
    'pf2': {
        name: { label: 'Name', icon: 'tag', iconSet: 'fas', color: 'text-blue-400', type: 'text' },
        category: { label: 'Category', icon: 'folder', iconSet: 'fas', color: 'text-orange-400', type: 'select', options: equipmentCategories },
        description: { label: 'Description', icon: 'align-left', iconSet: 'fas', color: 'text-cyan-400', type: 'text' },
        cost: { label: 'Cost', icon: 'coins', iconSet: 'fas', color: 'text-yellow-400', type: 'text' },
        weight: { label: 'Weight', icon: 'weight', iconSet: 'fas', color: 'text-green-400', type: 'text' },
        magic_effects: { label: 'Magic Effects', icon: 'magic', iconSet: 'fas', color: 'text-purple-400', type: 'text' },
        damage: { label: 'Damage', icon: 'sword', iconSet: 'far', color: 'text-red-400', type: 'dice' },
        range: { label: 'Range', icon: 'bullseye', iconSet: 'fas', color: 'text-amber-400', type: 'text' },
        armor: { label: 'Armor', icon: 'shield', iconSet: 'fas', color: 'text-emerald-400', type: 'number' },
        properties: { label: 'Properties', icon: 'list', iconSet: 'fas', color: 'text-gray-400', type: 'text' },
        ai_instructions: { label: 'AI Instructions', icon: 'robot', iconSet: 'fas', color: 'text-violet-400', type: 'text', adminOnly: true }
    }
}

// Helper functions
export function getCategoryLabel(value) {
    const category = equipmentCategories.find(cat => cat.value === value);
    return category ? category.label : value;
}

export function getPropertyConfig(item, propertyKey) {
    const edition = (item?.edition || '5e').toLowerCase();
    const editionConfig = editionProperties[edition] || editionProperties['5e'];
    return editionConfig[propertyKey];
}

export function getCurrentEditionProperties(item) {
    const edition = (item?.edition || '5e').toLowerCase();
    return editionProperties[edition] || editionProperties['5e'];
}

export function getPrimaryProperty(item) {
    if (item?.armor) {
        return { key: 'armor', value: item.armor, config: getPropertyConfig(item, 'armor') };
    }
    if (item?.damage) {
        return { key: 'damage', value: item.damage, config: getPropertyConfig(item, 'damage') };
    }
    if (item?.damage_dice) {
        return { key: 'damage_dice', value: item.damage_dice, config: getPropertyConfig(item, 'damage_dice') };
    }
    return null;
}